import {PureComponent} from 'react'
import PropTypes from 'prop-types'
import {withStyles} from '@material-ui/core/styles'

import EditIcon from '@material-ui/icons/Edit'
import DeleteIcon from '@material-ui/icons/Delete'
import Fab from '@material-ui/core/Fab'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'

import getString from "../config/strings";

const styles = theme => ({
    button: {
        margin: theme.spacing(1),
        overflow: 'hidden'
    },
    buttonCell: {
        verticalAlign: 'top',
        textAlign: 'center',
        padding: 0
    }
})

class DocumentTable extends PureComponent {

    render() {
        const {classes, card, openDialog, askDelete} = this.props

        if (card.files === null || card.files.length === 0) {
            return (<p>{getString('NO_DOCUMENTS')}</p>)
        }

        return (
            <Table className="documentList">
                <TableBody>
                    {card.files.map((document, index) =>
                        (<TableRow key={index}>
                            <TableCell className={classes.buttonCell}>
                                <Fab color="primary" aria-label="edit" size="small" className={classes.button}
                                     onClick={() => {
                                         openDialog(index)
                                     }}>
                                    <EditIcon/>
                                </Fab>
                            </TableCell>

                            <TableCell className="descriptionCell">
                                <a target="_blank" rel="noopener noreferrer"
                                   href={process.env.REACT_APP_DATA_HOST + '/rest/v1/documents/' + card.policy_number + '/' + document.fileorder}>{document.title}</a>
                                {document.description && (
                                    <div dangerouslySetInnerHTML={{__html: document.description}}/>)}
                            </TableCell>

                            <TableCell className={classes.buttonCell}>
                                <Fab color={"secondary"} aria-label="delete" size="small" className={classes.button}
                                     onClick={() => {
                                         askDelete(index)
                                     }}>
                                    <DeleteIcon/>
                                </Fab>
                            </TableCell>
                        </TableRow>)
                    )}
                </TableBody>
            </Table>
        )
    }
}

DocumentTable.propTypes = {
    classes: PropTypes.object.isRequired,
    card: PropTypes.object.isRequired,
    openDialog: PropTypes.func.isRequired,
    askDelete: PropTypes.func.isRequired
}

export default withStyles(styles)(DocumentTable)